import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

import { Button } from "@aviary";
import { l } from "@shared/locales/i18n";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./ShowAllTagButton.styles";

interface Props {
  handleClick: () => void;
  isShowingAll: boolean;
  remainder: number;
  "aria-label": string;
}

const ShowAllTagButton = ({ handleClick, isShowingAll, remainder, ...rest }: Props) => {
  const { t } = useTranslation();

  const renderIcon = () => {
    if (isShowingAll) {
      return <FontAwesomeIcon css={styles.icon} icon={faChevronLeft} size="xs" />;
    }

    return <p>+{remainder}</p>;
  };

  const label = isShowingAll ? t(l.sharedCommon.ShowLess) : t(l.sharedCommon.ShowAll);

  return (
    <Button isColor="system" css={styles.button} onClick={handleClick} {...rest}>
      <div css={styles.iconContainer}>{renderIcon()}</div>
      <p css={styles.label}>{label}</p>
    </Button>
  );
};

export { ShowAllTagButton };
